import { post, get } from './http';

export const sendcode = mobile => {
    var params = { mobile };
    return post('/sa/login/sendcode', params);
};

export const login = (mobile, scode) => {
    var params = { mobile, scode };
    return post('/sa/login', params);
};

export const logout = () => {
    var params = {};
    return get('/sa/logout', params);
};
